import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const ForcePinGate = () => {
  const { user, checkAuth } = useAuth();
  const [f, setF] = useState({ cur: "", n1: "", n2: "" });
  const [busy, setBusy] = useState(false);
  if (!user?.must_change_pin) return null;
  const ok = f.cur && /^\d{6}$/.test(f.n1) && f.n1 === f.n2;
  const save = async () => {
    setBusy(true);
    try { await api.changeOwnPassword(f.cur, f.n1); toast.success("تم تعيين الرمز السري الجديد"); await checkAuth(); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  return (
    <div dir="rtl" className="fixed inset-0 z-[200] flex items-center justify-center bg-slate-900/90 p-4" data-testid="force-pin-gate">
      <div className="w-full max-w-sm space-y-4 rounded-3xl bg-white p-6">
        <div className="text-center">
          <div className="mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-100"><KeyRound className="h-7 w-7 text-blue-600" /></div>
          <h2 className="font-heading text-lg font-extrabold text-slate-900">حدّث رمزك السري</h2>
          <p className="mt-1 text-xs text-slate-500">الرمز السري في الموقع صار 6 أرقام فقط. اختر رمزاً جديداً للمتابعة.</p>
        </div>
        <div className="space-y-1.5"><Label className="text-xs">كلمة المرور الحالية</Label>
          <Input type="password" dir="ltr" autoComplete="current-password" value={f.cur} onChange={(e) => setF({ ...f, cur: e.target.value })} data-testid="force-pin-current" /></div>
        <div className="space-y-1.5"><Label className="text-xs">الرمز الجديد (6 أرقام)</Label>
          <Input pin value={f.n1} onChange={(e) => setF({ ...f, n1: e.target.value })} className="h-11 text-center text-lg" data-testid="force-pin-new" /></div>
        <div className="space-y-1.5"><Label className="text-xs">تأكيد الرمز</Label>
          <Input pin value={f.n2} onChange={(e) => setF({ ...f, n2: e.target.value })} onKeyDown={(e) => e.key === "Enter" && ok && save()} className="h-11 text-center text-lg" data-testid="force-pin-confirm" /></div>
        {f.n2.length === 6 && f.n1 !== f.n2 && <p className="text-xs text-rose-600" data-testid="force-pin-mismatch">الرمزان غير متطابقين</p>}
        <Button className="h-11 w-full gap-1.5" disabled={!ok || busy} onClick={save} data-testid="force-pin-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ ومتابعة</Button>
      </div>
    </div>
  );
};
